export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    type: 'checkbox',
    width: 50,
    align: 'center',
    fixed: 'left',
  },
  {
    field: 'col-opt',
    title: '操作',
    align: 'center',
    width: 60,
    slots: { default: 'opt' },
  },
  {
    title: '车型',
    field: 'vehicleModel',
    align: 'center',
    minWidth: 100,
    editRender: {
      name: 'dict-select',
      props: {
        body: { type: 'vehicleModel' },
        placeholder: '请选择车型',
        default: true,
        clearable: true,
        filterable: true,
      },
    },
  },
  {
    title: '数量',
    field: 'qty',
    align: 'center',
    minWidth: 100,
    editRender: {
      name: 'ElInputNumber',
      attrs: {
        placeholder: '请输入单价',
        precision: 0,
        min: 0,
        'step-strictly': true,
      },
    },
  },
]
